import { supabase } from '../supabase/client.js';

const TABLE = 'watchvim_portal_access';

function unavailable(error) {
  const code = String(error?.code || '').toUpperCase();
  const message = String(error?.message || '');
  return code === '42P01'
    || code === 'PGRST205'
    || /relation .*watchvim_portal_access.* does not exist/i.test(message)
    || /could not find the table .*watchvim_portal_access/i.test(message);
}

export async function loadMyPortalAccess(userId) {
  if (!supabase || !userId) return [];

  const { data, error } = await supabase
    .from(TABLE)
    .select('portal,status,source,granted_at,updated_at')
    .eq('user_id', userId)
    .order('portal', { ascending: true });

  if (error) {
    if (unavailable(error)) return [];
    throw error;
  }

  return Array.isArray(data) ? data : [];
}

export function portalAccessMap(rows = []) {
  return Object.fromEntries((rows || []).map((row) => [row.portal, row]));
}

export function portalIsUsable(row) {
  return Boolean(row && ['invited', 'active'].includes(String(row.status || '').toLowerCase()));
}
